require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-eisenstadt-und-umgebung-zillingtal.json") })
        }
      }, "path---betreuungseinrichtungen-eisenstadt-und-umgebung-zillingtal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-eisenstadt-und-umgebung-zillingtal!./.cache/json/betreuungseinrichtungen-eisenstadt-und-umgebung-zillingtal.json
// module id = 879
// module chunks = 231608221292675